import { render, staticRenderFns } from "./ShopNav.vue?vue&type=template&id=dfcba584&"
import script from "./ShopNav.vue?vue&type=script&lang=js&"
export * from "./ShopNav.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/guave/madamesumcontao/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dfcba584')) {
      api.createRecord('dfcba584', component.options)
    } else {
      api.reload('dfcba584', component.options)
    }
    module.hot.accept("./ShopNav.vue?vue&type=template&id=dfcba584&", function () {
      api.rerender('dfcba584', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/madamesum/js/components/ShopNav.vue"
export default component.exports